var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 0.554504C24.8223 0.554504 32 7.73219 32 16.5545C32 25.3768 24.8223 32.5545 16 32.5545C7.17769 32.5545 0 25.3768 0 16.5545C0 7.73219 7.17769 0.554504 16 0.554504ZM16 2.87088C8.45478 2.87088 2.31638 9.01083 2.31638 16.5545C2.31638 24.0997 8.45478 30.2381 16 30.2381C23.5452 30.2381 29.6836 24.0997 29.6836 16.5545C29.6836 9.01083 23.5452 2.87088 16 2.87088ZM21.9787 10.5765C22.2829 10.8823 22.3941 11.3317 22.2644 11.7409L19.806 19.5996C19.6932 19.9625 19.4075 20.2467 19.0462 20.3594L11.1875 22.8194C11.0732 22.8549 10.9559 22.8719 10.8416 22.8719C10.5389 22.8719 10.2424 22.753 10.0216 22.5337C9.71736 22.2279 9.60618 21.7786 9.73589 21.3693L12.1959 13.5106C12.3086 13.1462 12.5928 12.8636 12.9541 12.7509L20.8128 10.2909C21.2251 10.1596 21.673 10.2723 21.9787 10.5765ZM19.3937 13.1616L14.225 14.78L12.6082 19.9486L17.7753 18.3302L19.3937 13.1616Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompass);
export default __webpack_public_path__ + "static/media/compass.a974b40f9301b1f06ba40fc88455d61a.svg";
export { ForwardRef as ReactComponent };